import {
  isAuthenticated,
  isClient,
  isEnterpriseAuthenticated,
  REBRAND_URLS,
} from '@cointracker/ui';

export const useAuth = () => {
  if (!isClient()) {
    return {
      isAuthenticated: false,
    };
  }
  if (window.location.pathname.includes(REBRAND_URLS.ENTERPRISE)) {
    return {
      isAuthenticated: isEnterpriseAuthenticated(),
    };
  }
  return {
    isAuthenticated: isAuthenticated,
  };
};
